import { Injectable, Inject, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser, isPlatformServer } from '@angular/common';

@Injectable({
  providedIn: 'root',
})
export class CheckPlatformService {
  constructor(@Inject(PLATFORM_ID) private platformId: Object) {}

  isBrowser(): boolean {
    let isBrowserPlatform: boolean = false;

    if (isPlatformBrowser(this.platformId)) {
      isBrowserPlatform = true;
    }

    return isBrowserPlatform;
  }

  isServer(): boolean {
    let isServerPlatform: boolean = false;

    if (isPlatformServer(this.platformId)) {
      isServerPlatform = true;
    }

    return isServerPlatform;
  }
}
